(function () {
  'use strict';
  if (!document.documentElement.classList.contains('dd-collection-layout-b')) return;
  if (window.GibbonCollectionVideo) {
    window.GibbonCollectionVideo.init(document);
    return;
  }

  function initHero(hero) {
    if (hero.dataset.gclVideoReady === 'true') return;
    var video = hero.querySelector('video');
    var toggle = hero.querySelector('[data-gcl-video-toggle]');
    if (!video || !toggle) return;
    hero.dataset.gclVideoReady = 'true';
    var mobile = window.matchMedia('(max-width: 680px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var userPaused = reducedMotion.matches;

    function updateControl() {
      var playing = !video.paused && !video.ended;
      toggle.dataset.playing = String(playing);
      toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
    }

    function setMedia(play) {
      var source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      var poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (poster) video.poster = poster;
      if (video.getAttribute('src') !== source) {
        video.pause();
        if (play && source) video.src = source;
        else video.removeAttribute('src');
        video.load();
      }
      if (play && source) {
        video.muted = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(updateControl);
      }
      updateControl();
    }

    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    video.addEventListener('error', function () {
      video.removeAttribute('src');
      video.load();
      updateControl();
    });
    toggle.addEventListener('click', function () {
      userPaused = !video.paused;
      if (userPaused) video.pause();
      else setMedia(true);
      updateControl();
    });
    mobile.addEventListener('change', function () { setMedia(!userPaused); });
    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches) {
        userPaused = true;
        video.pause();
      }
      updateControl();
    });
    toggle.hidden = false;
    setMedia(!userPaused);
  }

  function init(root) {
    root.querySelectorAll('[data-gcl-video-hero]').forEach(initHero);
  }

  window.GibbonCollectionVideo = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
